import {Injectable} from "@angular/core";
import {CanActivate, CanActivateChild, Router} from "@angular/router";
import {SessionTimeoutService} from "../../services";
import {SessionService} from "../../services/session/session.service";

@Injectable()
export class PhysicianPortalAuthGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router,
              private sessionTimeoutService: SessionTimeoutService,
              private sessionService: SessionService) {
  }

  canActivate() {
    let validRoles = ["physician", "assistant", "staff", "admin", "superadmin", "delegate"];
    let user = this.sessionService.getUser();
    if (user && validRoles.indexOf(user.Role) > -1) {
      sessionStorage.setItem("LastActiveTimestamp", new Date().toISOString());
      this.sessionTimeoutService.refreshTimer();
      return true;
    }

    this.router.navigate(["/login"]);
    return false;
  }

  canActivateChild() {
    return this.canActivate();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guard/physician-portal/physician-portal-auth.guard.ts